import React, { useEffect, useState } from 'react';
import TopNav from './TopNav';
import { letterLessons } from './letterLessons';
import { dariWords } from './dariWords';
import { listRecordedWords } from './audioStorage';
import { getProgress } from './letterProgress';
import LessonPage from './LessonPage';

function LettersPage() {
  const [recordedSet, setRecordedSet] = useState(new Set());
  const [selectedId, setSelectedId] = useState(null);
  const [progress, setProgress] = useState(getProgress());

  useEffect(() => {
    listRecordedWords(dariWords.map((w) => w.dari)).then(setRecordedSet).catch(() => {});
  }, []);

  // Refresh completion state whenever we return to the index.
  useEffect(() => {
    if (selectedId === null) setProgress(getProgress());
  }, [selectedId]);

  const selectedIndex = letterLessons.findIndex((l) => l.id === selectedId);
  const selected = selectedIndex >= 0 ? letterLessons[selectedIndex] : null;

  return (
    <div className='screen'>
      <TopNav active='letters' />

      <main className='quiz-card letters-card'>
        {selected ? (
          <LessonPage
            key={selected.id}
            lesson={selected}
            recordedSet={recordedSet}
            onBack={() => setSelectedId(null)}
            onNext={() => setSelectedId(letterLessons[selectedIndex + 1].id)}
            hasNext={selectedIndex + 1 < letterLessons.length}
          />
        ) : (
          <>
            <h1 className='letters-heading'>Learn the letters</h1>
            <p className='letters-intro'>
              Dari letters change shape at the start, middle and end of a word.
              Each lesson teaches a small set, then quizzes you with real words.
            </p>
            <ol className='lesson-list'>
              {letterLessons.map((lesson) => (
                <li key={lesson.id}>
                  <button
                    type='button'
                    className={`lesson-row${progress.completed[lesson.id] ? ' done' : ''}`}
                    onClick={() => setSelectedId(lesson.id)}
                  >
                    <span className='lesson-check'>{progress.completed[lesson.id] ? '✓' : '○'}</span>
                    <span className='lesson-row-text'>
                      <span className='lesson-row-title'>{lesson.title}</span>
                      <span className='lesson-row-letters' lang='fa' dir='rtl'>
                        {lesson.letters.join(' ')}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ol>
          </>
        )}
      </main>
    </div>
  );
}

export default LettersPage;
